import _ from 'lodash';

class MerchantTermsModalController {
  /* @ngInject */
  constructor(endPoints, docService, TermsService) {
    const that = this;

    that.openDoc = false;
    that.document = that.termini.filter((o) => o.stato === 1 && o.radiobutton === 0);
    that.terms = that.termini;
    that.errorDocOpen = false;
    that.allowed = false;
    that.loaderButton = false;

     that.checkOpenDoc = (term) => {
      that.errorDocOpen = !term.opened;
      //if (term.opened) {
        term.accepted = !term.accepted; // eslint-disable-line
        const notAcceptedTerm = that.terms.filter((o) => o.accepted === false);
        that.allowed = notAcceptedTerm.length === 0;
      //}
    };

    /*that.checkOpenDoc = (term) => {
      that.errorDocOpen = !that.openDoc;
      if (!that.errorDocOpen) {
        term.accepted = true; // eslint-disable-line
        const notAcceptedTerm = that.terms.filter((o) => o.accepted === false);
        that.allowed = notAcceptedTerm.length === 0;
      }
    };*/

    that.showPdf = (term) => {
      if (!term.opened) {
        term.opened = true; // eslint-disable-line
        const url = term.url;
        docService.showDoc(url, true);
      }
    };

    that.showContractPdf = () => {
      const url =`${endPoints.baseUrl}/api/usr/v2/documents/terms/200`
      docService.showDoc(url, true);
    }

    that.showDoc = (doc) => {
      that.openDoc = true;
      that.errorDocOpen = false;
      doc.accettato = 1; // eslint-disable-line
      that.showPdf(doc);
    };

    that.sendTerms = () => {
      that.loaderButton = true;
      var acceptedTerms = []
      //const terms = that.document.concat(that.terms);
      //_.forEach(terms, term => { delete term.opened; }); // eslint-disable-line
      _.forEach(that.terms, term => { acceptedTerms.push(term.termId ? term.termId : term.id) });
      TermsService.modifyTerms(acceptedTerms).then(() => {
        that.loaderButton = false;
        that.onClose();
      });
    };
  }
}

export default MerchantTermsModalController;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/merchantTermsModal/merchantTermsModal.controller.js
 **/